var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("w-select", {
    attrs: { value: _vm.value, items: _vm.items, label: _vm.label, fancy: "" },
    on: { input: _vm.onInput },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }